import { createFileRoute } from '@tanstack/react-router';

import { requireGuest } from '@/app/lib/auth-guard';
import { CreateUserPage } from '@/auth/pages/create-user';

export const Route = createFileRoute('/_login-signup/create-user')({
  beforeLoad: () => {
    requireGuest();
  },
  component: CreateUserRoute
});

function CreateUserRoute() {
  return <CreateUserPage/>;
}
